import { createFileRoute, Navigate } from "@tanstack/react-router"
import { SearchSchema } from "./list/route"

import "modules/campaigns/lang"

export const Route = createFileRoute("/_base/_auth/campaigns/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/campaigns/list" search={SearchSchema.parse({})} replace />
}
